import React from 'react';

import ListDevis from './listDevis'
import Details from './details'
import Documents from './documents';
import Comparateurs from './comparateurs'
import CopyBox from './copyBox'
import working from './img/working.png'

import { StatusMarker, StatusPicker } from './status'
import ItemTabBar from './itemTabBar';
import Timeline from './timeline'
import SearchBar from './searchBar'
import Tarifs from './tarifs'
import tools from './img/tools-line.png'

import warningImg from './img/error-warning-line.png'

const typeToSponsor = {'motoecole':'Moto-école','concessionnaire':'Concessionnaire'}

class CommercialList extends React.Component {

    constructor(props) {

        super(props);
    }

    onChange(event) {
        this.props.container.setCommercial(event.target.value)
    }

    render() {
        let me = this
        if ( !this.props.isAdmin ) {
            let commercial = this.props.commercial
            if ( commercial=='false' ) commercial = false
            if ( commercial ) {
                return <span>{commercial}</span>
            } else {
                return <button onClick={e=>{
                    e.stopPropagation()
                    me.props.container.setCommercial(me.props.user)
                }}>Prendre ce devis</button>
            }
        } else {
            let options = this.props.users.map(
                user=><option key={user.login} value={user.login}>{user.login}</option>
            )
            return <select onChange={this.onChange.bind(this)}
                onClick={e=>{e.stopPropagation()}}
                value={this.props.commercial}>
                <option value={false}>-</option>
                {options}
            </select>
        }
    }
}

class Devis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unfold:false,
            editComment:'',
            copied:false,
            searchName:'',
            fetchingSolly:false
        }
        this.dateFormatter = new Intl.DateTimeFormat('fr',{ dateStyle: 'short', timeStyle: 'short' })
    }    

    pickStatus(status) {
        this.props.container.pickStatus(this.props.devis._id.$oid,status)
    }

    setCommercial(commercial) {
        this.props.container.setCommercial(this.props.devis._id.$oid,commercial)
    }

    sendDevisEmail(onSuccess) {
        if ( window.confirm('Envoyer le devis à '+this.props.devis.params.email) ) {
            this.props.container.sendDevisEmail(this.props.devis._id.$oid,onSuccess)
        } else {
            onSuccess()
        }
    }

    onComment() {
        this.props.container.setComment(this.props.devis._id.$oid,this.state.editComment)
        this.setState({editComment:''})
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
      
    getTarif(formule) {
        const warranties = this.props.devis.params.warranties
        if ( warranties ) {
            const found = warranties.find( row => row.Z_FORM == formule )
            return found ? found.Z_MTAN+' €' : ''
        }
        return ''
    }

    unfoldMarker(e) {
        this.openTimeline(e)
    }

    openTimeline(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'timeline'})
    }

    openEmailList(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        if ( this.props.topLevel ) {
            this.setState({unfold:'emaillist'})
        }
    }

    openClient(e) {
        if (e && e.target ) {
            e.stopPropagation()
        }
        this.props.api.openFront(this.props.devis)
    }

    openDetails(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'details'})
    }


    openTarifs(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'tarifs'})
    }

    openDocuments(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'documents'})
    }

    openComparateurs(e) {
        if (e && e.target && ! this.state.unfold ) {
            e.stopPropagation()
        }
        this.setState({unfold:'comparateurs'})
    }

    fold() {
        if ( this.state.unfold ) {
            this.setState({unfold:false})
        } else {
            this.setState({unfold:this.props.devis.params.error?'comparateurs':'timeline'})
        }
    }

    setStatusProcess(option) {
        this.props.container.setStatusProcess(this.props.devis._id.$oid,option)
    }

    renderTimeline() {

        return <Timeline container={this} devis={this.props.devis} api={this.props.api}/>
    }

    renderDetails() {
        return <Details container={this} api={this.props.api} devis={this.props.devis}/>
    }

    renderComparateurs() {
        return <Comparateurs container={this} api={this.props.api} devis={this.props.devis}/>
    }

    renderEmailList() {
        return <ListDevis 
            container={this} 
            api={this.props.api} 
            email={this.props.devis.params.email} 
            avoid={this.props.devis._id.$oid}
            filterName=""
            searchStatus={[]}
        />
    }

    renderDocuments() {
        return <Documents container={this} api={this.props.api} devis={this.props.devis}/>
    }

    renderStatus() {
        return <StatusPicker container={this} api={this.props.api} status={this.props.devis.status}/>
    }

    renderTarifs() {
        return <Tarifs container={this} api={this.props.api} devis={this.props.devis}/>
    }


    renderUnfolded(type) {
        let content = ''
        switch ( this.state.unfold ) {
            case 'timeline':
                content = this.renderTimeline()
                break
            case 'emaillist':
                content = this.renderEmailList()
                break
            case 'details':
                content =  this.renderDetails()
                break
            case 'comparateurs':
                content = this.renderComparateurs()
                break
            case 'status':
                content = this.renderStatus()
                break
            case 'tarifs':
                content = this.renderTarifs()
                break
            case 'documents':
                content = this.renderDocuments()
                break
            }
        if ( content ) {
            return <React.Fragment>
                <ItemTabBar container={this} tab={this.state.unfold} type={type} showClient={true} />
                <div className="unfolded_block">
                {content}
                </div>
            </React.Fragment>
        } else {
            return content
        }
    }

    fetchSolly(e) {
        e.stopPropagation()
        this.setState({fetchingSolly:true})
        const me = this
        this.props.api.post(
            {   action:'goons_tarif',
                id:this.props.devis._id.$oid
            },
            ()=>{
                me.setState({fetchingSolly:false})
            },
            ()=>{
                me.setState({fetchingSolly:false})
            }
        )
    }

    validateSolly(e) {
        e.stopPropagation()
        this.setState({fetchingSolly:true})
        const me = this
        this.props.api.post(
            {   action:'goons_validate',
                id:this.props.devis._id.$oid
            },
            ()=>{
                me.setState({fetchingSolly:false})
            },
            ()=>{
                me.setState({fetchingSolly:false})
            }
        )
    }

    renderApporteur() {
        const {params,affiliate} = this.props.devis
        if ( affiliate ) {
            return 'Affilié '+affiliate
        } 
        return ( 'Ref_Partenaire' in params ) ? params.Ref_Partenaire : 'Website'
    }

    render() {
        
        const {operator,devis} = this.props
        const params = devis.params

        let filtered = params.filtered
        if ( filtered &&( filtered.length > 24 )) filtered = filtered.substring(24)
        else filtered = ''

        if ( params.error && !params.nom ) {
            return <React.Fragment>
                <tr onClick={this.fold.bind(this)}><td className="nowrap">
                        <img title="Rédiger un commentaire" src='img/pencil-line.png' className='button' onClick={this.openTimeline.bind(this)}/>
                        <img title="Détails du devis" src='img/search-2-line.png' className='button' onClick={this.openComparateurs.bind(this)}/>
                    </td>
                    <td colSpan="5">{this.props.devis.params.error}{filtered}</td>
                    <td>{this.props.devis.cm} ({this.props.devis.cc})</td>
                    <td>{( 'Ref_Partenaire' in this.props.devis.params )?this.props.devis.params.Ref_Partenaire:'Website'}</td>
                    <td>{this.props.devis.params.date_effet}</td>
                    <td>{this.dateFormatter.format(1000*this.props.devis.params.Abp_Timestamp)}</td></tr>
                <tr className={this.state.unfold ? 'unfolded':'folded'}><td colSpan="11">{this.renderUnfolded('error')}</td></tr>
            </React.Fragment> 
        }

        return (this.props.quotations || !this.props.devis.params.nom) ? <React.Fragment>
            <tr onClick={this.fold.bind(this)}>
                <td className="nowrap">
                    <img title="Voir l'historique" src='img/time-line.png' className='button' onClick={this.openTimeline.bind(this)}/>
                    <img title="Rédiger un commentaire" src='img/pencil-line.png' className='button' onClick={this.openTimeline.bind(this)}/>
                    <img title="Détails du devis" src='img/search-2-line.png' className='button' onClick={this.openDetails.bind(this)}/>
                </td>
                <td>{this.getTarif('M2')}</td>
                <td>{this.getTarif('M3')}</td>
                <td>{this.getTarif('M4')}</td>
                <td>{this.getTarif('M7')}</td>
                <td onClick={this.openDetails.bind(this)}>{this.props.devis.params.marque+' / '+this.props.devis.params.modele+' ('+this.props.devis.params.cylindree+')'}</td>
                <td>{this.props.devis.cm} ({this.props.devis.cc})</td>
                <td>{( 'Ref_Partenaire' in this.props.devis.params )?this.props.devis.params.Ref_Partenaire:'Website'}</td>
                <td>{this.props.devis.params.date_effet}</td>
                <td>{this.props.devis.params.Abp_Timestamp ? this.dateFormatter.format(1000*this.props.devis.params.Abp_Timestamp) : ''}</td>
            </tr>
            <tr className={this.state.unfold ? 'unfolded':'folded'}>
                <td colSpan="11">{this.renderUnfolded('tarif')}</td>
            </tr>
        </React.Fragment> 
        : 
        <React.Fragment>
            <tr onClick={this.fold.bind(this)} className={'progress_'+devis.getStage()}>
                {operator ? <td>
                    <CommercialList container={this} commercial={devis.commercial} users={this.props.users} user={this.props.api.getLogin()} isAdmin={this.props.api.isAdmin()}/>
                </td> : <></>}
                <td>
                    <StatusMarker container={this} status={this.props.devis.status || 'Non traité'} unfolded={this.props.unfoldedMarker}/>
                    { this.props.devis.synchronized ? '' : <img className="working" src={working} title="Ce dossier est en cours de modification"/> }
                    {((devis.validated<0)||( params.validated &&( params.validated < 0 )))?<img src={tools} className="working" title="Devis en attente de validation pas Xenassur. Souscription impossible avant validation."/>:''}
                </td>
                <td onClick={this.openDetails.bind(this)}>
                    {this.props.devis.params.nom.toUpperCase()+' '+this.capitalizeFirstLetter( this.props.devis.params.prenom )}
                </td>
                <td onClick={this.openDetails.bind(this)} className="wrapword">
                    {this.props.devis.params.email}
                </td>
                <td onClick={this.openDetails.bind(this)}>
                    <CopyBox text={'0'+this.props.devis.params.telephone}/>
                </td>
                <td onClick={this.openTarifs.bind(this)}>
                    {this.props.devis.toPay()}<br/>{(params.periodicite=='M')?this.props.devis.toPayMonthly():'-'}
                </td>
                {operator?<><td onClick={this.openTarifs.bind(this)} className={this.state.fetchingSolly?'fetching narrow_right narrow_left solly':'narrow_right narrow_left solly'}>{devis.hasSollyTarifs()
                    ? ( 
                        (params.periodicite=='A')
                        ? (
                            <>{devis.sollyAnnuel()}<br/>-</>
                        ) : (
                            <>{devis.sollyAcompte()}<br/>{devis.sollyMensuel()}<br/></>
                        )
                    ) : ''}
                    {( devis.solly_validated < 0 ) ? <span title={devis.solly_error||''}>Erreur</span> : ''}

                </td>
                <td onClick={this.openTarifs.bind(this)} className={this.state.fetchingSolly?'fetching narrow_left':'narrow_left'}>
                

                <button className="solly" onClick={this.state.fetchingSolly ? false : this.fetchSolly.bind(this)}>Tarifer</button>
                {( devis.solly_ref &&(( devis.solly_validated == 0 )||( devis.solly_validated == -1 ))) ? <button className="solly" onClick={this.validateSolly.bind(this)}>Valider</button> : ''}
                {( devis.solly_ref &&( devis.solly_validated == 1 )) ? <button className="solly checked">Validé</button> : ''}


                </td></>:<></>}
                <td onClick={this.openDetails.bind(this)}>{this.props.devis.params.marque+' / '+this.props.devis.params.modele+' ('+this.props.devis.params.cylindree+')'}</td>
                {operator?<td>{devis.cm} ({devis.cc})</td>:<></>}
                <td onClick={this.openTimeline.bind(this)} >
                    {SearchBar.statusProcessToLabel(devis.status_process)}
                    {( devis.subscriber &&( devis.status_process != 'ongoing' )&&( devis.status_process != 'subscribed_solly' ))?<><br/>par {devis.subscriber}</>:<></>}
                </td>
                <td onClick={this.openTimeline.bind(this)}>{this.renderApporteur()}</td>
                {operator?<>
                <td>
                    {params.subscribeId 
                        ? <>Contrat <CopyBox text={this.props.devis.params.subscribeId}/></>
                        : <>Devis<CopyBox text={this.props.devis.params.idt}/></>
                    }
                </td>
                <td><CopyBox text={devis._id.$oid} displayText={devis._id.$oid.substring(0,6)+'...'}/>
                {this.props.devis.params.trans_uuid?<><CopyBox text={this.props.devis.params.trans_uuid} displayText={this.props.devis.params.trans_uuid.substring(0,6)+'...'}/></>:<></>}
                </td>
                <td>{(this.props.devis.params.MER in Devis.merToLabel )? Devis.merToLabel[this.props.devis.params.MER] : '-'}</td>
                </>:<></>}
                <td>{this.props.devis.params.date_effet}</td>
                <td>{this.dateFormatter.format(1000*this.props.devis.last_modification)}</td>
                <td>{this.dateFormatter.format(1000*this.props.devis.params.Abp_Timestamp)}</td>
                <td>{devis.getStageText()}</td>
            </tr>
            {this.props.devis.has_devis?'':<tr onClick={this.openDetails.bind(this)}><td></td><td colSpan="9"><img src={warningImg} className="inline-icon"/> Erreur lors de l'édition du devis {this.props.devis.params.error ? ('- Message de xenassur: '+this.props.devis.params.error):''}</td></tr>}
            {((this.props.devis.status_process=='subscribe_error')||(this.props.devis.status_process=='presubscribe_error'))?<tr onClick={this.openDetails.bind(this)} className="error"><td></td><td colSpan="9"><img src={warningImg} className="inline-icon"/> Erreur lors de la souscription {this.props.devis.params.error ? (' : '+this.props.devis.params.error):''}</td></tr>:''}
            {(this.props.devis.getting_documents<0)?<tr onClick={this.openDetails.bind(this)} className="error"><td></td><td colSpan="9"><img src={warningImg} className="inline-icon"/> Erreur lors de la récupération des documents ! Le client n'a pas reçu ses documents.</td></tr>:''}

            {( devis.solly_validated < 0 ) ? <tr onClick={this.fold.bind(this)} className="error_solly"><td colSpan="3"></td><td colSpan="15"><b>Sollyazar ▸ </b> {devis.solly_error||''}</td></tr> : ''}

            <tr className={this.state.unfold ? 'unfolded':'folded'}><td colSpan="15">{this.renderUnfolded(this.props.devis.params.subscribeId?'subscribed':'devis')}</td></tr>
        </React.Fragment>
    }
}

Devis.merToLabel = {
    'M':'Mail',
    'C':'Courrier',
    'T':'Téléphone',
    'W':'Web call back',
    'S':'Souscrire en ligne'
}

export default Devis;
